<template>
  <screen
    v-show="show"
    :screen-name="$t('tutorial.title')"
    :screen-info="$t('tutorial.feet_pos')"
    @skip="$emit('skip')"
  >
    <circle-window>
      <feet />
    </circle-window>
  </screen>
</template>

<script>
import autoNext from '@/mixins/auto-next';

import Screen from '../common/Screen.vue';
import CircleWindow from './CircleWindow.vue';
import Feet from './Feet.vue';

export default {
  name: 'FeetPos',
  components: {
    Screen,
    CircleWindow,
    Feet,
  },
  mixins: [autoNext],
  data: () => ({
    duration: 3.5,
    audioKey: '11_tutorial_position_feet',
  }),
};
</script>
